import React from 'react'
import "./Checkout.css"
import CheckoutProduct from './CheckoutProduct'
import { useStateValue } from './StateProvider'
import Subtotal from './Subtotal'
function Checkout() {
    const [{basket,user},dispatch] = useStateValue();
    
    return (
        <div className="checkout">
            <div className="checkout__left">
                <img className="checkout__ad"
                src="https://images-eu.ssl-images-amazon.com/images/G/31/img20/Events/jupiter20/affordability/phase2/Header_PC_1500x178_English1.jpg"
                 alt=""
                />

              <div>
                <h3> {user ? " Hello" : "Dear"} , {user ? (user?.email) : "Guest Please Kindly login first"}</h3>
                <h2 className='checkout__title'> Your
                shopping Basket</h2>
               
                 {basket.map(item => (
                 <CheckoutProduct 
                 id={item.id}
                 title={item.title}
                 image={item.image}
                 price={item.price}
                 rating={item.rating}

                 />
                 ))}
                


              </div>
             </div>
            <div className="checkout__right">
                <Subtotal/>
                <h2>The subtotal will go here</h2>
                
            </div>
        </div>
    )
}

export default Checkout
